"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IPAPER = void 0;
const IPAPER = exports.IPAPER = 'iframe';
